/**
 * @generated SignedSource<<08ab134370f387b805bf1b20c55a46fa>>
 * @relayHash 5a0344405bd5edcdc9f8e2e29142b426
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d189dd7e6235b7df5ea9fcbf2c345decfb0ae4b81b17e6f9543f2bceea5104b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d189dd7e6235b7df5ea9fcbf2c345decfb0ae4b81b17e6f9543f2bceea5104b9",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
